import React, { Component, Fragment } from 'react'
import { FormSubmit, FormWrapper } from '@myxplor/forms'
import RemoteRequest from '../../remote-request'
import { errorHandler as defaultErrorHandler } from '../../io/error-handling'
import FormFromErrors from './form-from-errors'

export const getRemoteRequestPayload = ({ remote_request }) => {
  const { data, errors, success } = remote_request.state

  return {
    data: !data ? [] : data.constructor === Object ? [data] : data,
    errors: !errors ? [] : errors,
    success,
  }
}

const calculateSubmitValues = (props, values) =>
  props.calculateSubmitValues ? props.calculateSubmitValues(values) : values

export class DefaultForm extends Component {
  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  componentDidUpdate(prevProps) {
    const { data, errors, success } = getRemoteRequestPayload(this.props)
    const { success: prevSuccess } = getRemoteRequestPayload(prevProps)

    if (success && !prevSuccess) {
      this.props.handleSuccess({ data, errors })
    }
  }

  submit(url) {
    if(this.props.onBeforeSubmit) {
      this.props.onBeforeSubmit();
    }

    return values => {
      this.props.remote_request.submit(url, {
        method: 'POST',
        jsonAPI: true,
        body: calculateSubmitValues(this.props, values),
      })
    }
  }

  render() {
    const {
      remote_request,
      url,
      formOptions,
      name,
      formComponent,
      canDisplayErrors,
      label,
      loadingTitle = 'Saving changes...',
      errorHandler = defaultErrorHandler,
    } = this.props

    let { loading } = remote_request.state
    const errors = errorHandler(remote_request.state)

    if (!url) return null

    return (
      <FormWrapper
        {...formOptions || {}}
        // FYI: We have a key, so values from other GovActions don't leak between forms
        key={name}
        onSubmit={this.submit(url)}
        render={formProps => (
          <Fragment>
            {// custom components are optional
              formComponent &&
              React.createElement(formComponent, {
                ...formProps,
                loading,
                errors,
              })}

            <FormFromErrors
              errors={errors}
              onChange={formProps.onChange}
              onlyDisplayErrors={canDisplayErrors}
            />

            <FormSubmit
              loadingTitle={loadingTitle}
              loading={loading}
              disabled={!formProps.valid}
              errors={errors.summary}>
              {label}
            </FormSubmit>
          </Fragment>
        )}
      />
    )
  }
}

export default RemoteRequest(DefaultForm)



// WEBPACK FOOTER //
// ./src/ui/forms/default-form.jsx